import { deleteToken } from 'firebase/messaging';
import { getErrorReporter } from 'shared/services/error-tracking';
import { ID } from 'shared/types/id';

import { deletePushToken } from './delete-push-token';
import { getPushNotificationToken, initPushNotifications } from './helpers';

// platform-specific twin of mobile's resetPushRegistration (firebase JS messaging vs native installations)
export const resetPushRegistration = async (uid: ID) => {
  const messaging = initPushNotifications();

  await deleteToken(messaging).catch((error) => {
    getErrorReporter().captureException(error, {
      tags: { source: 'reset-push-registration' },
    });
  });

  const cachedToken = getPushNotificationToken(uid);
  if (!cachedToken) {
    return;
  }

  await deletePushToken(cachedToken);
};
